// src/config/emailConfig.js - MAİL ADRESLERI KONFÜGÜRASYON

// ✅ Ortama göre admin maili değiştir
export const EMAIL_CONFIG = {
  // Geliştirme ortamı
  DEVELOPMENT: {
    ADMIN_EMAIL: 'ibrahimayy03@gmail.com', // ✅ Test için kendi mailin
    FROM_EMAIL: 'noreply@tronapazarlama.com',
    ENABLED: true
  },
  
  // Canlı ortam
  PRODUCTION: {
    ADMIN_EMAIL: 'info@tronapazarlama.com', // ✅ Canlıda gerçek admin mail
    FROM_EMAIL: 'noreply@tronapazarlama.com',
    ENABLED: true
  }
};

// ✅ Mevcut ortamı belirle (localhost = dev, canlı domain = prod)
const isProduction = window.location.hostname !== 'localhost' && 
                     !window.location.hostname.includes('127.0.0.1');

// ✅ Aktif konfigürasyonu seç
export const ACTIVE_EMAIL_CONFIG = isProduction 
  ? EMAIL_CONFIG.PRODUCTION 
  : EMAIL_CONFIG.DEVELOPMENT;

// ✅ Kolay erişim için export
export const ADMIN_EMAIL = ACTIVE_EMAIL_CONFIG.ADMIN_EMAIL;
export const FROM_EMAIL = ACTIVE_EMAIL_CONFIG.FROM_EMAIL;
export const EMAIL_ENABLED = ACTIVE_EMAIL_CONFIG.ENABLED;

console.log('📧 Email Config:', {
  environment: isProduction ? 'PRODUCTION' : 'DEVELOPMENT',
  adminEmail: ADMIN_EMAIL,
  enabled: EMAIL_ENABLED
});